import { RecommendationContextProto } from "@noom/noom-contracts/noom_contracts/recommender/shared";
import getStore from "../redux/store";
import { trackBuyflowEvent } from "../api/tracker";
import { MED_SKU } from "../medEligibility";

function getMedTierItemIdMap() {
  return {
    [MED_SKU.BRANDED_ZEPBOUND_VIAL]: "medBrandedZepboundVialPlan",
    [MED_SKU.BRANDED]: "medBrandedPlan",
    [MED_SKU.COMPOUNDED]: "medCompoundedPlan",
    [MED_SKU.GENERIC_LIRAGLUTIDE]: "medLiraglutidePlan",
    [MED_SKU.ORALS_METFORMIN]: "medOralsPlan",
    [MED_SKU.HRT_CREAM]: "hrtCreamPlan",
    [MED_SKU.HRT_PATCH]: "hrtPatchPlan",
    [MED_SKU.COMPOUNDED_MICRODOSE]: "medMicrodosePlan",
  };
}

export function getRecommendationContextProto(
  medTier: MED_SKU
): RecommendationContextProto {
  const { userData, recommendationContext } = getStore().getState();
  const growthUserId = userData.user_id;
  const positionViewed =
    recommendationContext?.eligibleMedTiers?.indexOf(medTier);
  const medTierItemIdMap = getMedTierItemIdMap();
  return {
    itemId: medTierItemIdMap[medTier],
    userId: { growthUserId },
    recommendationSurface: "MED_PLAN_OFFER",
    positionViewed,
  };
}

export function trackRecommendedOfferClicked(medTier: MED_SKU) {
  trackBuyflowEvent("BuyflowRecommendedItemClicked", {
    recommendationContext: getRecommendationContextProto(medTier),
  });
}

export function trackRecommendedOfferViewed(medTier: MED_SKU) {
  trackBuyflowEvent("BuyflowRecommendedItemViewed", {
    recommendationContext: getRecommendationContextProto(medTier),
  });
}

export function trackRecommendedOfferDeclined(medTier: MED_SKU) {
  trackBuyflowEvent("BuyflowRecommendedItemDeclined", {
    recommendationContext: getRecommendationContextProto(medTier),
  });
}
